<script setup>
const props = defineProps({
	src: {
		type: String,
		required: true,
	},
	alt: {
		type: String,
		required: true,
	},
})
</script>

<template>
	<div class="w-fit bg-white p-1 pb-10">
		<div class="flex aspect-video h-44 items-center justify-center">
			<img class="h-full" :src="src" :alt="alt" />
		</div>
	</div>
</template>
